import React from 'react';
import { Link } from 'react-router-dom';
import { Gift, Mail, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#561D1A] text-white/80">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 bg-[#EC1A23] rounded-lg flex items-center justify-center">
                <Gift size={16} className="text-white" />
              </div>
              <span className="font-heading text-white text-lg font-bold">LuxeMall</span>
            </div>
            <p className="text-sm leading-relaxed">
              The premier digital gift voucher platform for modern shopping experiences.
            </p>
          </div>
          <div>
            <h4 className="text-white font-medium mb-3 text-sm uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Shop Vouchers</Link></li>
              <li><Link to="/account" className="hover:text-white transition-colors">Sign In</Link></li>
              <li><Link to="/merchant" className="hover:text-white transition-colors">Merchant Portal</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-medium mb-3 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2"><Mail size={14} /> support@luxemall.com</li>
              <li className="flex items-center gap-2"><Phone size={14} /> +254 700 000 000</li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-white/10 text-center text-xs text-white/40">
          © {new Date().getFullYear()} LuxeMall Gift Vouchers. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
